import React  from 'react';
import loader from './splash-loader.svg';
import * as styledComponents from './styles';

const Loader = (props) => {
  return (
    <styledComponents.LoaderWrapper show={props.show}>
      <img src={loader} alt="" />
    </styledComponents.LoaderWrapper>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/ui/Loader/index.js